@import 'styles/mixins';

.facebookOAuthButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  color: white;
}

.button {
  background-color: #1877f2;
  border-radius: 10px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: #4a90e2;
  }
}

.facebookButton {
  @include for-desktop-only {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
